import axios from 'axios'
import auth from '@/auth/index'

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL
})

api.interceptors.request.use((config) => {
  if (auth.isLogged()) {
    config.headers.Authorization = `Bearer ${auth.getTokenLogged()}`
  }
  return config
})

function getErrorMessage (error, fallback) {
  return (error && error.response && error.response.data && error.response.data.message) || fallback
}

export default {
  async downloadBankAccountsTemplate () {
    try {
      const response = await api.get('bulk-imports/templates/bank-accounts', {
        responseType: 'blob'
      })
      return response
    } catch (error) {
      throw new Error(getErrorMessage(error, 'No fue posible descargar la plantilla.'))
    }
  },

  async uploadBankAccountsFile (file) {
    try {
      const formData = new FormData()
      formData.append('file', file)
      const response = await api.post('bulk-imports/bank-accounts/upload', formData)
      return response.data.job
    } catch (error) {
      throw new Error(getErrorMessage(error, 'No fue posible procesar el archivo.'))
    }
  },

  async getJob (jobId) {
    try {
      const response = await api.get(`bulk-imports/${jobId}`)
      return response.data.job
    } catch (error) {
      throw new Error(getErrorMessage(error, 'No fue posible obtener la carga.'))
    }
  },

  async listJobs (params = {}) {
    try {
      const response = await api.get('bulk-imports', { params })
      return response.data
    } catch (error) {
      throw new Error(getErrorMessage(error, 'No fue posible obtener las cargas recientes.'))
    }
  },

  async getJobRows (jobId, params = {}) {
    try {
      const response = await api.get(`bulk-imports/${jobId}/rows`, { params })
      return response.data
    } catch (error) {
      throw new Error(getErrorMessage(error, 'No fue posible obtener las filas de la carga.'))
    }
  },

  async confirmJob (jobId) {
    try {
      const response = await api.post(`bulk-imports/${jobId}/confirm`)
      return response.data.job
    } catch (error) {
      throw new Error(getErrorMessage(error, 'No fue posible confirmar la carga.'))
    }
  },

  async cancelJob (jobId) {
    try {
      const response = await api.post(`bulk-imports/${jobId}/cancel`)
      return response.data.job
    } catch (error) {
      throw new Error(getErrorMessage(error, 'No fue posible cancelar la carga.'))
    }
  }
}
